// import fetch from "cross-fetch"
import fetch from "isomorphic-fetch"
import apolloClient from "./../utils/apollo/client"

// export default apolloClient({ uri: "http://localhost:3000/api", fetch })
export default apolloClient({
  uri: typeof window !== "undefined" && window['siteConfig']?.graphQLAPI,
  fetch,
})
